export const Theme = "Theme"

export const setTheme = (payload) => ({
    type:Theme,
    payload
})